import { Component, OnInit } from '@angular/core';
import { AllPageService } from "src/app/shared/services/all-page.service";
import { NgForm, FormsModule } from "@angular/forms";
declare var jQuery: any;
declare var $: any;

@Component({
  selector: 'app-partnership',
  templateUrl: './partnership.component.html',
  styleUrls: ['./partnership.component.scss']
})
export class PartnershipComponent implements OnInit {

  partnershipList: any = "";
  partnershipgeneralList: any = "";
  contactRequest: any = {};
  contactError: any;
  contactSuccess: any;
  bannerrequest: any = {};
  bannerList: any = "";
  sponsorsList: any = "";

  constructor(private allpagesService: AllPageService,) { }


  ngOnInit() {
    this.loadBanner();
    this.allpagesService.getCommercialPartnership().then((data) => {
      this.partnershipList = data.data.other[0];
      this.partnershipgeneralList = data.data.general[0];
     // console.log(this.partnershipList);
      //console.log(this.partnershipgeneralList);
    });
    this.loadBannernew();
    this.allpagesService.getSponsors().then((data) => {
      this.sponsorsList = data;
      console.log(this.sponsorsList);
    });
    setTimeout(() => {

      var accordionParentClass = ' .faq-title';
					var accordionQuestionClass = ' .faq-title .faq-add';
					var accordionContentClass = ' .faq-content';
				
					jQuery(accordionParentClass).each(function() {
					jQuery( this ).addClass('close');
					jQuery( this ).find(accordionContentClass).hide();
					});
					
					jQuery(accordionQuestionClass).click(function(){
					var faqClass = jQuery(this).closest(accordionParentClass).attr('class');
					
					if(faqClass.indexOf('close') != -1){
						//WHEN CLOSED
						jQuery(accordionParentClass).find(accordionContentClass).slideUp('slow'); //CLOSE ALL
						jQuery(accordionParentClass).addClass('close').removeClass('open'); //set all faq as closed
						
						jQuery(this).closest(accordionParentClass).removeClass('close');
						jQuery(this).closest(accordionParentClass).addClass('open');
						// jQuery( this ).closest(accordionParentClass).find(accordionContentClass).slideDown('slow');
						
					} else {
						jQuery(this).closest(accordionParentClass).addClass('close');
						jQuery(this).closest(accordionParentClass).removeClass('open');
						// jQuery( this ).closest(accordionParentClass).find(accordionContentClass).slideUp('slow');
					}
					
					});
      // jQuery(".faq-title ").on("click", function () {
      //   jQuery(".faq-title").removeClass('active');
      //   if (jQuery(this).toggleClass('active')) {
      //     // do nothing
      //   }
      //   return false;
      // });


    }, 1000);
  }

  clubContactus(form: NgForm) {
    if (form.valid) {

      let request: any = {};
      request = Object.assign({}, this.contactRequest);
      this.allpagesService.getClubContactus(request).then((res) => {

        if (res.status == 0) {
          this.contactError = res.message;
        } else {
          this.contactSuccess = res.message;
          form.reset();
        }
      })
        .catch((err) => {
          this.contactError = err.res.message;
        });
    }
  }

  loadBanner() {
    this.bannerrequest = {
      title: 'Partnership Opportunities'
    };
    let request = Object.assign({}, this.bannerrequest);
    this.allpagesService.getBannerList(request).then((data: any) => {
      this.bannerList = data.data[0];
      //console.log(this.bannerList);
    });
  }
  loadBannernew() {
    this.bannerrequest = {
      title: "Official Partners"
    };
    let request = Object.assign({}, this.bannerrequest);
    this.allpagesService.getBannerList(request).then((data: any) => {
      this.bannerList = data.data[0];
      console.log(this.bannerList);
    });
  }

}
